'use client';
// import logoDark from '@/assets/images/logo-dark.png';
// import LogoLight from '@/assets/images/logo-light.png'; // Không dùng đến
import IconifyIcon from '@/components/wrappers/IconifyIcon';
// import Image from 'next/image';
import Link from 'next/link';
import { useEffect } from 'react';
import { Button, Card, CardBody, Col, Container, Row } from 'react-bootstrap';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/context/AuthContext';

const SignIn = () => {
  const router = useRouter();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      router.push('/dashboards');
    }
  }, [isAuthenticated, router]);

  const signInGoogle = () => {
    const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL;
    window.location.href = `${baseUrl}/auth/google`;
  };

  return (
    <div className="account-pages min-vh-100 bg-gradient-custom">
      {/* Gradient background */}
      <Container>
        <Row className="justify-content-center align-items-center min-vh-100">
          {/* Căn giữa theo chiều dọc */}
          <Col xl={4} lg={5} md={6}>
            <Card
              className="auth-card shadow-lg border-0 rounded-3 mx-auto"
              style={{ maxWidth: '400px' }}
            >
              {/* Card style */}
              <CardBody className="p-4">
                <div className="text-center mb-5">
                  {/* Tăng margin bottom */}

                  <Link href="/dashboards">
                    <h1 className="font-bold text-[24px] ">CLB Bơi Thủ Đô</h1>
                  </Link>
                </div>
                <h4 className="text-center mb-4 fw-bold text-white fs-24">
                  Đăng nhập
                </h4>
                {/* Màu chữ trắng, tăng kích thước */}
                <div className="d-grid">
                  <Button
                    variant="light"
                    className="py-2 rounded-pill d-flex align-items-center justify-content-center"
                    onClick={signInGoogle}
                    style={{ borderColor: '#ddd' }}
                  >
                    <IconifyIcon
                      icon="bxl:google"
                      className="fs-20 me-2"
                      style={{ color: '#DB4437' }}
                    />
                    <span className="text-dark">Đăng nhập bằng Google</span>
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SignIn;
